import type { FitChoice } from "../../shared/types";
import { fitOptions } from "../lib/fitExperience";
export function FitPhoto({ fit, compact = false }: { fit: FitChoice; compact?: boolean }) {
  const option = fitOptions.find((item) => item.value === fit)!;
  return <figure className={`fit-photo ${compact ? "fit-photo--compact" : ""}`}><img src={option.image} alt={`Esempio illustrativo di T-shirt con vestibilità ${option.label}`} width="1024" height="1536"/><span className="photo-fit-name">{option.label}</span><figcaption>Immagine illustrativa · non è una simulazione del tuo corpo</figcaption></figure>;
}
